import { createFileRoute } from '@tanstack/react-router';

import { PlanPdfPrint } from '@/modules/SharedPlanning/print/PlanPdfPrint';

const PlanPdfPrintRoute = () => {
  const { renderToken } = Route.useParams();
  return <PlanPdfPrint renderToken={renderToken} />;
};

export const Route = createFileRoute('/print/plan-pdfs/$renderToken')({
  component: PlanPdfPrintRoute,
});
